import { render } from "./AddUserDataView.vue?vue&type=template&id=31a32448"
import script from "./AddUserDataView.vue?vue&type=script&lang=js"
export * from "./AddUserDataView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/baojian/Documents/anyway/anyway-wx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__